/* eslint @typescript-eslint/no-var-requires: "off" */
import { getNames, registerLocale } from 'i18n-iso-countries';
import { AppLocale } from 'src/models/modules';

const locales = [AppLocale.Hu.toString(), AppLocale.De.toString(), AppLocale.Sk.toString(), AppLocale.En.toString()];

locales.forEach((locale) => {
    registerLocale(require(`i18n-iso-countries/langs/${locale}.json`));
});

export const getCountryOptions = (locale: string) =>
    Object.keys(getNames(locale)).map((alpha2Code) => ({
        value: alpha2Code,
        label: getNames(locale)[alpha2Code],
    })).sort((a, b) => a.label.localeCompare(b.label)); 